/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getDeliveredMessages = /* GraphQL */ `query GetDeliveredMessages($id: ID!) {
  getDeliveredMessages(id: $id) {
    id
    recipientEmail
    recipientId
    recipientUserId
    deliveredAt
    deliveryType
    messageRead
    readReminderCount
    readReminderStatus
    status
    failureReason
    attemptCount
    lastAttemptAt
    statusUpdatedAt
    fromUserProfileId
    fromName
    fromEmail
    originalMessageId
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    hasAttachment
    attachmentCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDeliveredMessagesQueryVariables,
  APITypes.GetDeliveredMessagesQuery
>;
export const listDeliveredMessages = /* GraphQL */ `query ListDeliveredMessages(
  $filter: ModelDeliveredMessagesFilterInput
  $limit: Int
  $nextToken: String
) {
  listDeliveredMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      recipientEmail
      recipientId
      recipientUserId
      deliveredAt
      deliveryType
      messageRead
      readReminderCount
      readReminderStatus
      status
      failureReason
      attemptCount
      lastAttemptAt
      statusUpdatedAt
      fromUserProfileId
      fromName
      fromEmail
      originalMessageId
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      hasAttachment
      attachmentCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeliveredMessagesQueryVariables,
  APITypes.ListDeliveredMessagesQuery
>;
export const deliveredMessagesByRecipientEmail = /* GraphQL */ `query DeliveredMessagesByRecipientEmail(
  $recipientEmail: AWSEmail!
  $deliveredAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDeliveredMessagesFilterInput
  $limit: Int
  $nextToken: String
) {
  deliveredMessagesByRecipientEmail(
    recipientEmail: $recipientEmail
    deliveredAt: $deliveredAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      recipientEmail
      recipientId
      recipientUserId
      deliveredAt
      deliveryType
      messageRead
      readReminderCount
      readReminderStatus
      status
      failureReason
      attemptCount
      lastAttemptAt
      statusUpdatedAt
      fromUserProfileId
      fromName
      fromEmail
      originalMessageId
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      hasAttachment
      attachmentCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DeliveredMessagesByRecipientEmailQueryVariables,
  APITypes.DeliveredMessagesByRecipientEmailQuery
>;
export const deliveredMessagesByStatusAndStatusUpdatedAt = /* GraphQL */ `query DeliveredMessagesByStatusAndStatusUpdatedAt(
  $status: String!
  $statusUpdatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDeliveredMessagesFilterInput
  $limit: Int
  $nextToken: String
) {
  deliveredMessagesByStatusAndStatusUpdatedAt(
    status: $status
    statusUpdatedAt: $statusUpdatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      recipientEmail
      recipientId
      recipientUserId
      deliveredAt
      deliveryType
      messageRead
      readReminderCount
      readReminderStatus
      status
      failureReason
      attemptCount
      lastAttemptAt
      statusUpdatedAt
      fromUserProfileId
      fromName
      fromEmail
      originalMessageId
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      hasAttachment
      attachmentCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DeliveredMessagesByStatusAndStatusUpdatedAtQueryVariables,
  APITypes.DeliveredMessagesByStatusAndStatusUpdatedAtQuery
>;
export const deliveredMessagesByOriginalMessageId = /* GraphQL */ `query DeliveredMessagesByOriginalMessageId(
  $originalMessageId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDeliveredMessagesFilterInput
  $limit: Int
  $nextToken: String
) {
  deliveredMessagesByOriginalMessageId(
    originalMessageId: $originalMessageId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      recipientEmail
      recipientId
      recipientUserId
      deliveredAt
      deliveryType
      messageRead
      readReminderCount
      readReminderStatus
      status
      failureReason
      attemptCount
      lastAttemptAt
      statusUpdatedAt
      fromUserProfileId
      fromName
      fromEmail
      originalMessageId
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      hasAttachment
      attachmentCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DeliveredMessagesByOriginalMessageIdQueryVariables,
  APITypes.DeliveredMessagesByOriginalMessageIdQuery
>;
export const getDeliveredMessagesAttachments = /* GraphQL */ `query GetDeliveredMessagesAttachments($id: ID!) {
  getDeliveredMessagesAttachments(id: $id) {
    id
    deliveredMessageId
    recipientEmail
    fileName
    fileType
    fileSize
    s3Key
    uploadedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDeliveredMessagesAttachmentsQueryVariables,
  APITypes.GetDeliveredMessagesAttachmentsQuery
>;
export const listDeliveredMessagesAttachments = /* GraphQL */ `query ListDeliveredMessagesAttachments(
  $filter: ModelDeliveredMessagesAttachmentsFilterInput
  $limit: Int
  $nextToken: String
) {
  listDeliveredMessagesAttachments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      deliveredMessageId
      recipientEmail
      fileName
      fileType
      fileSize
      s3Key
      uploadedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeliveredMessagesAttachmentsQueryVariables,
  APITypes.ListDeliveredMessagesAttachmentsQuery
>;
export const attachmentsByDeliveredMessageId = /* GraphQL */ `query AttachmentsByDeliveredMessageId(
  $deliveredMessageId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDeliveredMessagesAttachmentsFilterInput
  $limit: Int
  $nextToken: String
) {
  attachmentsByDeliveredMessageId(
    deliveredMessageId: $deliveredMessageId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      deliveredMessageId
      recipientEmail
      fileName
      fileType
      fileSize
      s3Key
      uploadedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AttachmentsByDeliveredMessageIdQueryVariables,
  APITypes.AttachmentsByDeliveredMessageIdQuery
>;
export const deliveredMessageAttachmentsByRecipientEmail = /* GraphQL */ `query DeliveredMessageAttachmentsByRecipientEmail(
  $recipientEmail: AWSEmail!
  $sortDirection: ModelSortDirection
  $filter: ModelDeliveredMessagesAttachmentsFilterInput
  $limit: Int
  $nextToken: String
) {
  deliveredMessageAttachmentsByRecipientEmail(
    recipientEmail: $recipientEmail
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      deliveredMessageId
      recipientEmail
      fileName
      fileType
      fileSize
      s3Key
      uploadedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DeliveredMessageAttachmentsByRecipientEmailQueryVariables,
  APITypes.DeliveredMessageAttachmentsByRecipientEmailQuery
>;
export const getMessageDeliveryLog = /* GraphQL */ `query GetMessageDeliveryLog($id: ID!) {
  getMessageDeliveryLog(id: $id) {
    id
    executionId
    actionType
    entityType
    entityId
    originalMessageId
    deliveredMessageId
    recipientId
    previousStatus
    newStatus
    attemptNumber
    errorSummary
    changedFields
    timestamp
    functionName
    details
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessageDeliveryLogQueryVariables,
  APITypes.GetMessageDeliveryLogQuery
>;
export const listMessageDeliveryLogs = /* GraphQL */ `query ListMessageDeliveryLogs(
  $filter: ModelMessageDeliveryLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listMessageDeliveryLogs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      executionId
      actionType
      entityType
      entityId
      originalMessageId
      deliveredMessageId
      recipientId
      previousStatus
      newStatus
      attemptNumber
      errorSummary
      changedFields
      timestamp
      functionName
      details
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMessageDeliveryLogsQueryVariables,
  APITypes.ListMessageDeliveryLogsQuery
>;
export const getTestimonials = /* GraphQL */ `query GetTestimonials($id: ID!) {
  getTestimonials(id: $id) {
    id
    Name
    Location
    Comment
    Active
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTestimonialsQueryVariables,
  APITypes.GetTestimonialsQuery
>;
export const listTestimonials = /* GraphQL */ `query ListTestimonials(
  $filter: ModelTestimonialsFilterInput
  $limit: Int
  $nextToken: String
) {
  listTestimonials(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      Name
      Location
      Comment
      Active
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTestimonialsQueryVariables,
  APITypes.ListTestimonialsQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    cognitoSub
    email
    status
    UserProfile {
      id
      firstName
      lastName
      preferredName
      dateOfBirth
      primaryPhone
      primaryPhoneType
      secondaryPhone
      secondaryPhoneType
      isActive
      isAlive
      eolVerificationCount
      lastEolVerificationResponseAt
      lastEolVerificationSentAt
      eolVerificationStatus
      currentEolVerificationCycleStartedAt
      lastEolVerificationMethod
      lastSuccessfulLoginAt
      Messages {
        nextToken
        __typename
      }
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    UserPreferences {
      id
      eolVerificationIntervalDays
      eolVerificationReminderCount
      eolVerificationReminderIntervalDays
      eolVerificationChannelEmailEnabled
      eolVerificationChannelSmsEnabled
      eolStopScheduledMessages
      minBodyWordCount
      eolAccountReaderRecipientId
      preferredLanguage
      createdAt
      updatedAt
      __typename
    }
    billingProviderId
    userPlanId
    pendingPlanId
    scheduledPlanId
    planStatus
    planSelectedAt
    planActivatedAt
    checkoutSessionRef
    checkoutMode
    pendingPaymentAmount
    pendingPaymentQuotedAt
    latestPaymentId
    currentPeriodEnd
    billingProvider
    billingCustomerRef
    subscriptionId
    ChangeLogs {
      items {
        id
        requestId
        changedById
        userId
        entityType
        entityId
        changeType
        fieldName
        oldValue
        newValue
        metadata
        dateTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cognitoSub
      email
      status
      UserProfile {
        id
        firstName
        lastName
        preferredName
        dateOfBirth
        primaryPhone
        primaryPhoneType
        secondaryPhone
        secondaryPhoneType
        isActive
        isAlive
        eolVerificationCount
        lastEolVerificationResponseAt
        lastEolVerificationSentAt
        eolVerificationStatus
        currentEolVerificationCycleStartedAt
        lastEolVerificationMethod
        lastSuccessfulLoginAt
        createdAt
        updatedAt
        __typename
      }
      UserPreferences {
        id
        eolVerificationIntervalDays
        eolVerificationReminderCount
        eolVerificationReminderIntervalDays
        eolVerificationChannelEmailEnabled
        eolVerificationChannelSmsEnabled
        eolStopScheduledMessages
        minBodyWordCount
        eolAccountReaderRecipientId
        preferredLanguage
        createdAt
        updatedAt
        __typename
      }
      billingProviderId
      userPlanId
      pendingPlanId
      scheduledPlanId
      planStatus
      planSelectedAt
      planActivatedAt
      checkoutSessionRef
      checkoutMode
      pendingPaymentAmount
      pendingPaymentQuotedAt
      latestPaymentId
      currentPeriodEnd
      billingProvider
      billingCustomerRef
      subscriptionId
      ChangeLogs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const userByEmail = /* GraphQL */ `query UserByEmail(
  $email: AWSEmail!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoSub
      email
      status
      UserProfile {
        id
        firstName
        lastName
        preferredName
        dateOfBirth
        primaryPhone
        primaryPhoneType
        secondaryPhone
        secondaryPhoneType
        isActive
        isAlive
        eolVerificationCount
        lastEolVerificationResponseAt
        lastEolVerificationSentAt
        eolVerificationStatus
        currentEolVerificationCycleStartedAt
        lastEolVerificationMethod
        lastSuccessfulLoginAt
        createdAt
        updatedAt
        __typename
      }
      UserPreferences {
        id
        eolVerificationIntervalDays
        eolVerificationReminderCount
        eolVerificationReminderIntervalDays
        eolVerificationChannelEmailEnabled
        eolVerificationChannelSmsEnabled
        eolStopScheduledMessages
        minBodyWordCount
        eolAccountReaderRecipientId
        preferredLanguage
        createdAt
        updatedAt
        __typename
      }
      billingProviderId
      userPlanId
      pendingPlanId
      scheduledPlanId
      planStatus
      planSelectedAt
      planActivatedAt
      checkoutSessionRef
      checkoutMode
      pendingPaymentAmount
      pendingPaymentQuotedAt
      latestPaymentId
      currentPeriodEnd
      billingProvider
      billingCustomerRef
      subscriptionId
      ChangeLogs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserByEmailQueryVariables,
  APITypes.UserByEmailQuery
>;
export const getUserProfile = /* GraphQL */ `query GetUserProfile($id: ID!) {
  getUserProfile(id: $id) {
    id
    firstName
    lastName
    preferredName
    dateOfBirth
    primaryPhone
    primaryPhoneType
    secondaryPhone
    secondaryPhoneType
    isActive
    isAlive
    eolVerificationCount
    lastEolVerificationResponseAt
    lastEolVerificationSentAt
    eolVerificationStatus
    currentEolVerificationCycleStartedAt
    lastEolVerificationMethod
    lastSuccessfulLoginAt
    Messages {
      items {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Recipients {
      items {
        id
        firstName
        lastName
        email
        phone
        phoneType
        sendSMS
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        name
        description
        type
        status
        size
        s3Key
        uploadDate
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserProfileQueryVariables,
  APITypes.GetUserProfileQuery
>;
export const listUserProfiles = /* GraphQL */ `query ListUserProfiles(
  $filter: ModelUserProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      firstName
      lastName
      preferredName
      dateOfBirth
      primaryPhone
      primaryPhoneType
      secondaryPhone
      secondaryPhoneType
      isActive
      isAlive
      eolVerificationCount
      lastEolVerificationResponseAt
      lastEolVerificationSentAt
      eolVerificationStatus
      currentEolVerificationCycleStartedAt
      lastEolVerificationMethod
      lastSuccessfulLoginAt
      Messages {
        nextToken
        __typename
      }
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserProfilesQueryVariables,
  APITypes.ListUserProfilesQuery
>;
export const getUserPreferences = /* GraphQL */ `query GetUserPreferences($id: ID!) {
  getUserPreferences(id: $id) {
    id
    eolVerificationIntervalDays
    eolVerificationReminderCount
    eolVerificationReminderIntervalDays
    eolVerificationChannelEmailEnabled
    eolVerificationChannelSmsEnabled
    eolStopScheduledMessages
    minBodyWordCount
    eolAccountReaderRecipientId
    preferredLanguage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserPreferencesQueryVariables,
  APITypes.GetUserPreferencesQuery
>;
export const listUserPreferences = /* GraphQL */ `query ListUserPreferences(
  $filter: ModelUserPreferencesFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserPreferences(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      eolVerificationIntervalDays
      eolVerificationReminderCount
      eolVerificationReminderIntervalDays
      eolVerificationChannelEmailEnabled
      eolVerificationChannelSmsEnabled
      eolStopScheduledMessages
      minBodyWordCount
      eolAccountReaderRecipientId
      preferredLanguage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserPreferencesQueryVariables,
  APITypes.ListUserPreferencesQuery
>;
export const getPlatformLimits = /* GraphQL */ `query GetPlatformLimits($id: ID!) {
  getPlatformLimits(id: $id) {
    id
    maxRecipientsPerMessage
    maxAttachmentsPerMessage
    maxGeneralFileSizeBytes
    maxVideoFileSizeBytes
    maxStorageBytesPerUser
    maxTotalAttachmentSizePerMessage
    allowedExtensions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlatformLimitsQueryVariables,
  APITypes.GetPlatformLimitsQuery
>;
export const listPlatformLimits = /* GraphQL */ `query ListPlatformLimits(
  $filter: ModelPlatformLimitsFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlatformLimits(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      maxRecipientsPerMessage
      maxAttachmentsPerMessage
      maxGeneralFileSizeBytes
      maxVideoFileSizeBytes
      maxStorageBytesPerUser
      maxTotalAttachmentSizePerMessage
      allowedExtensions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlatformLimitsQueryVariables,
  APITypes.ListPlatformLimitsQuery
>;
export const getUserPlatformLimits = /* GraphQL */ `query GetUserPlatformLimits($id: ID!) {
  getUserPlatformLimits(id: $id) {
    id
    platformLimitOverrides
    storageUsedBytes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserPlatformLimitsQueryVariables,
  APITypes.GetUserPlatformLimitsQuery
>;
export const listUserPlatformLimits = /* GraphQL */ `query ListUserPlatformLimits(
  $filter: ModelUserPlatformLimitsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserPlatformLimits(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      platformLimitOverrides
      storageUsedBytes
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserPlatformLimitsQueryVariables,
  APITypes.ListUserPlatformLimitsQuery
>;
export const getEolVerificationToken = /* GraphQL */ `query GetEolVerificationToken($id: ID!) {
  getEolVerificationToken(id: $id) {
    id
    userId
    cycleId
    tokenHash
    status
    issuedAt
    expiresAt
    usedAt
    channel
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEolVerificationTokenQueryVariables,
  APITypes.GetEolVerificationTokenQuery
>;
export const listEolVerificationTokens = /* GraphQL */ `query ListEolVerificationTokens(
  $filter: ModelEolVerificationTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  listEolVerificationTokens(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      cycleId
      tokenHash
      status
      issuedAt
      expiresAt
      usedAt
      channel
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEolVerificationTokensQueryVariables,
  APITypes.ListEolVerificationTokensQuery
>;
export const eolVerificationTokensByUser = /* GraphQL */ `query EolVerificationTokensByUser(
  $userId: ID!
  $issuedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEolVerificationTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  eolVerificationTokensByUser(
    userId: $userId
    issuedAt: $issuedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      cycleId
      tokenHash
      status
      issuedAt
      expiresAt
      usedAt
      channel
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EolVerificationTokensByUserQueryVariables,
  APITypes.EolVerificationTokensByUserQuery
>;
export const eolVerificationTokensByCycle = /* GraphQL */ `query EolVerificationTokensByCycle(
  $cycleId: String!
  $issuedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEolVerificationTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  eolVerificationTokensByCycle(
    cycleId: $cycleId
    issuedAt: $issuedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      cycleId
      tokenHash
      status
      issuedAt
      expiresAt
      usedAt
      channel
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EolVerificationTokensByCycleQueryVariables,
  APITypes.EolVerificationTokensByCycleQuery
>;
export const eolVerificationTokenByTokenHash = /* GraphQL */ `query EolVerificationTokenByTokenHash(
  $tokenHash: String!
  $sortDirection: ModelSortDirection
  $filter: ModelEolVerificationTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  eolVerificationTokenByTokenHash(
    tokenHash: $tokenHash
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      cycleId
      tokenHash
      status
      issuedAt
      expiresAt
      usedAt
      channel
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EolVerificationTokenByTokenHashQueryVariables,
  APITypes.EolVerificationTokenByTokenHashQuery
>;
export const getRecipient = /* GraphQL */ `query GetRecipient($id: ID!) {
  getRecipient(id: $id) {
    id
    firstName
    lastName
    email
    phone
    phoneType
    sendSMS
    userprofileID
    messages {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecipientQueryVariables,
  APITypes.GetRecipientQuery
>;
export const listRecipients = /* GraphQL */ `query ListRecipients(
  $filter: ModelRecipientFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecipients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      firstName
      lastName
      email
      phone
      phoneType
      sendSMS
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecipientsQueryVariables,
  APITypes.ListRecipientsQuery
>;
export const recipientsByUserprofileID = /* GraphQL */ `query RecipientsByUserprofileID(
  $userprofileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecipientFilterInput
  $limit: Int
  $nextToken: String
) {
  recipientsByUserprofileID(
    userprofileID: $userprofileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      firstName
      lastName
      email
      phone
      phoneType
      sendSMS
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RecipientsByUserprofileIDQueryVariables,
  APITypes.RecipientsByUserprofileIDQuery
>;
export const getMessage = /* GraphQL */ `query GetMessage($id: ID!) {
  getMessage(id: $id) {
    id
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    status
    scheduledDate
    endOfLifeTrigger
    size
    userprofileID
    Recipients {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sentDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessageQueryVariables,
  APITypes.GetMessageQuery
>;
export const listMessages = /* GraphQL */ `query ListMessages(
  $filter: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMessagesQueryVariables,
  APITypes.ListMessagesQuery
>;
export const messagesByUserprofileID = /* GraphQL */ `query MessagesByUserprofileID(
  $userprofileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  messagesByUserprofileID(
    userprofileID: $userprofileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessagesByUserprofileIDQueryVariables,
  APITypes.MessagesByUserprofileIDQuery
>;
export const getPlan = /* GraphQL */ `query GetPlan($id: ID!) {
  getPlan(id: $id) {
    id
    name
    description
    type
    price
    billingCycle
    status
    messagesAllowed
    attachmentsAllowed
    recipientsAllowed
    billingProviderId
    checkoutMode
    priceId
    billingConfig
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPlanQueryVariables, APITypes.GetPlanQuery>;
export const listPlans = /* GraphQL */ `query ListPlans(
  $filter: ModelPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      type
      price
      billingCycle
      status
      messagesAllowed
      attachmentsAllowed
      recipientsAllowed
      billingProviderId
      checkoutMode
      priceId
      billingConfig
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListPlansQueryVariables, APITypes.ListPlansQuery>;
export const getBillingProvider = /* GraphQL */ `query GetBillingProvider($id: ID!) {
  getBillingProvider(id: $id) {
    id
    billingProviderId
    billingProviderName
    providerCode
    isActive
    checkoutMode
    webhookEnabled
    apiBaseUrl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBillingProviderQueryVariables,
  APITypes.GetBillingProviderQuery
>;
export const listBillingProviders = /* GraphQL */ `query ListBillingProviders(
  $filter: ModelBillingProviderFilterInput
  $limit: Int
  $nextToken: String
) {
  listBillingProviders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      billingProviderId
      billingProviderName
      providerCode
      isActive
      checkoutMode
      webhookEnabled
      apiBaseUrl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBillingProvidersQueryVariables,
  APITypes.ListBillingProvidersQuery
>;
export const getAttachment = /* GraphQL */ `query GetAttachment($id: ID!) {
  getAttachment(id: $id) {
    id
    name
    description
    type
    status
    size
    s3Key
    uploadDate
    userprofileID
    messages {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAttachmentQueryVariables,
  APITypes.GetAttachmentQuery
>;
export const listAttachments = /* GraphQL */ `query ListAttachments(
  $filter: ModelAttachmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAttachments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      type
      status
      size
      s3Key
      uploadDate
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAttachmentsQueryVariables,
  APITypes.ListAttachmentsQuery
>;
export const attachmentsByUserprofileID = /* GraphQL */ `query AttachmentsByUserprofileID(
  $userprofileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAttachmentFilterInput
  $limit: Int
  $nextToken: String
) {
  attachmentsByUserprofileID(
    userprofileID: $userprofileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      type
      status
      size
      s3Key
      uploadDate
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AttachmentsByUserprofileIDQueryVariables,
  APITypes.AttachmentsByUserprofileIDQuery
>;
export const getChangeLog = /* GraphQL */ `query GetChangeLog($id: ID!) {
  getChangeLog(id: $id) {
    id
    requestId
    changedById
    userId
    entityType
    entityId
    changeType
    fieldName
    oldValue
    newValue
    metadata
    dateTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChangeLogQueryVariables,
  APITypes.GetChangeLogQuery
>;
export const listChangeLogs = /* GraphQL */ `query ListChangeLogs(
  $filter: ModelChangeLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listChangeLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      requestId
      changedById
      userId
      entityType
      entityId
      changeType
      fieldName
      oldValue
      newValue
      metadata
      dateTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeLogsQueryVariables,
  APITypes.ListChangeLogsQuery
>;
export const changeLogsByUserId = /* GraphQL */ `query ChangeLogsByUserId(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelChangeLogFilterInput
  $limit: Int
  $nextToken: String
) {
  changeLogsByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      requestId
      changedById
      userId
      entityType
      entityId
      changeType
      fieldName
      oldValue
      newValue
      metadata
      dateTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ChangeLogsByUserIdQueryVariables,
  APITypes.ChangeLogsByUserIdQuery
>;
export const getLegalAcceptance = /* GraphQL */ `query GetLegalAcceptance($id: ID!) {
  getLegalAcceptance(id: $id) {
    id
    userId
    version
    acceptedAt
    sessionId
    sourceApp
    clientType
    browser
    os
    userAgent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLegalAcceptanceQueryVariables,
  APITypes.GetLegalAcceptanceQuery
>;
export const listLegalAcceptances = /* GraphQL */ `query ListLegalAcceptances(
  $filter: ModelLegalAcceptanceFilterInput
  $limit: Int
  $nextToken: String
) {
  listLegalAcceptances(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      version
      acceptedAt
      sessionId
      sourceApp
      clientType
      browser
      os
      userAgent
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLegalAcceptancesQueryVariables,
  APITypes.ListLegalAcceptancesQuery
>;
export const legalAcceptancesByUser = /* GraphQL */ `query LegalAcceptancesByUser(
  $userId: ID!
  $acceptedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLegalAcceptanceFilterInput
  $limit: Int
  $nextToken: String
) {
  legalAcceptancesByUser(
    userId: $userId
    acceptedAt: $acceptedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      version
      acceptedAt
      sessionId
      sourceApp
      clientType
      browser
      os
      userAgent
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LegalAcceptancesByUserQueryVariables,
  APITypes.LegalAcceptancesByUserQuery
>;
export const getLoginEvent = /* GraphQL */ `query GetLoginEvent($id: ID!) {
  getLoginEvent(id: $id) {
    id
    userId
    eventType
    occurredAt
    sessionId
    sourceApp
    clientType
    browser
    os
    userAgent
    authMethod
    mfaUsed
    ipHash
    country
    region
    city
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLoginEventQueryVariables,
  APITypes.GetLoginEventQuery
>;
export const listLoginEvents = /* GraphQL */ `query ListLoginEvents(
  $filter: ModelLoginEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listLoginEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      eventType
      occurredAt
      sessionId
      sourceApp
      clientType
      browser
      os
      userAgent
      authMethod
      mfaUsed
      ipHash
      country
      region
      city
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLoginEventsQueryVariables,
  APITypes.ListLoginEventsQuery
>;
export const loginEventsByUser = /* GraphQL */ `query LoginEventsByUser(
  $userId: ID!
  $occurredAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLoginEventFilterInput
  $limit: Int
  $nextToken: String
) {
  loginEventsByUser(
    userId: $userId
    occurredAt: $occurredAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      eventType
      occurredAt
      sessionId
      sourceApp
      clientType
      browser
      os
      userAgent
      authMethod
      mfaUsed
      ipHash
      country
      region
      city
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LoginEventsByUserQueryVariables,
  APITypes.LoginEventsByUserQuery
>;
export const loginEventsByEventType = /* GraphQL */ `query LoginEventsByEventType(
  $eventType: LoginEventType!
  $occurredAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLoginEventFilterInput
  $limit: Int
  $nextToken: String
) {
  loginEventsByEventType(
    eventType: $eventType
    occurredAt: $occurredAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      eventType
      occurredAt
      sessionId
      sourceApp
      clientType
      browser
      os
      userAgent
      authMethod
      mfaUsed
      ipHash
      country
      region
      city
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LoginEventsByEventTypeQueryVariables,
  APITypes.LoginEventsByEventTypeQuery
>;
export const getBillingEventLog = /* GraphQL */ `query GetBillingEventLog($id: ID!) {
  getBillingEventLog(id: $id) {
    id
    userId
    provider
    providerEventId
    providerCustomerRef
    providerResourceRef
    eventType
    status
    planId
    amount
    currency
    occurredAt
    receivedAt
    processedAt
    message
    rawPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBillingEventLogQueryVariables,
  APITypes.GetBillingEventLogQuery
>;
export const listBillingEventLogs = /* GraphQL */ `query ListBillingEventLogs(
  $filter: ModelBillingEventLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listBillingEventLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      provider
      providerEventId
      providerCustomerRef
      providerResourceRef
      eventType
      status
      planId
      amount
      currency
      occurredAt
      receivedAt
      processedAt
      message
      rawPayload
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBillingEventLogsQueryVariables,
  APITypes.ListBillingEventLogsQuery
>;
export const billingEventLogsByUser = /* GraphQL */ `query BillingEventLogsByUser(
  $userId: ID!
  $receivedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelBillingEventLogFilterInput
  $limit: Int
  $nextToken: String
) {
  billingEventLogsByUser(
    userId: $userId
    receivedAt: $receivedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      provider
      providerEventId
      providerCustomerRef
      providerResourceRef
      eventType
      status
      planId
      amount
      currency
      occurredAt
      receivedAt
      processedAt
      message
      rawPayload
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BillingEventLogsByUserQueryVariables,
  APITypes.BillingEventLogsByUserQuery
>;
export const billingEventLogByProviderEventId = /* GraphQL */ `query BillingEventLogByProviderEventId(
  $providerEventId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelBillingEventLogFilterInput
  $limit: Int
  $nextToken: String
) {
  billingEventLogByProviderEventId(
    providerEventId: $providerEventId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      provider
      providerEventId
      providerCustomerRef
      providerResourceRef
      eventType
      status
      planId
      amount
      currency
      occurredAt
      receivedAt
      processedAt
      message
      rawPayload
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BillingEventLogByProviderEventIdQueryVariables,
  APITypes.BillingEventLogByProviderEventIdQuery
>;
export const getMessageRecipient = /* GraphQL */ `query GetMessageRecipient($id: ID!) {
  getMessageRecipient(id: $id) {
    id
    recipientId
    messageId
    recipient {
      id
      firstName
      lastName
      email
      phone
      phoneType
      sendSMS
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    message {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessageRecipientQueryVariables,
  APITypes.GetMessageRecipientQuery
>;
export const listMessageRecipients = /* GraphQL */ `query ListMessageRecipients(
  $filter: ModelMessageRecipientFilterInput
  $limit: Int
  $nextToken: String
) {
  listMessageRecipients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      recipientId
      messageId
      recipient {
        id
        firstName
        lastName
        email
        phone
        phoneType
        sendSMS
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      message {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMessageRecipientsQueryVariables,
  APITypes.ListMessageRecipientsQuery
>;
export const messageRecipientsByRecipientId = /* GraphQL */ `query MessageRecipientsByRecipientId(
  $recipientId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMessageRecipientFilterInput
  $limit: Int
  $nextToken: String
) {
  messageRecipientsByRecipientId(
    recipientId: $recipientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      recipientId
      messageId
      recipient {
        id
        firstName
        lastName
        email
        phone
        phoneType
        sendSMS
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      message {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessageRecipientsByRecipientIdQueryVariables,
  APITypes.MessageRecipientsByRecipientIdQuery
>;
export const messageRecipientsByMessageId = /* GraphQL */ `query MessageRecipientsByMessageId(
  $messageId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMessageRecipientFilterInput
  $limit: Int
  $nextToken: String
) {
  messageRecipientsByMessageId(
    messageId: $messageId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      recipientId
      messageId
      recipient {
        id
        firstName
        lastName
        email
        phone
        phoneType
        sendSMS
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      message {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessageRecipientsByMessageIdQueryVariables,
  APITypes.MessageRecipientsByMessageIdQuery
>;
export const getMessageAttachment = /* GraphQL */ `query GetMessageAttachment($id: ID!) {
  getMessageAttachment(id: $id) {
    id
    messageId
    attachmentId
    message {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    attachment {
      id
      name
      description
      type
      status
      size
      s3Key
      uploadDate
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessageAttachmentQueryVariables,
  APITypes.GetMessageAttachmentQuery
>;
export const listMessageAttachments = /* GraphQL */ `query ListMessageAttachments(
  $filter: ModelMessageAttachmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listMessageAttachments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      messageId
      attachmentId
      message {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      attachment {
        id
        name
        description
        type
        status
        size
        s3Key
        uploadDate
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMessageAttachmentsQueryVariables,
  APITypes.ListMessageAttachmentsQuery
>;
export const messageAttachmentsByMessageId = /* GraphQL */ `query MessageAttachmentsByMessageId(
  $messageId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMessageAttachmentFilterInput
  $limit: Int
  $nextToken: String
) {
  messageAttachmentsByMessageId(
    messageId: $messageId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      messageId
      attachmentId
      message {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      attachment {
        id
        name
        description
        type
        status
        size
        s3Key
        uploadDate
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessageAttachmentsByMessageIdQueryVariables,
  APITypes.MessageAttachmentsByMessageIdQuery
>;
export const messageAttachmentsByAttachmentId = /* GraphQL */ `query MessageAttachmentsByAttachmentId(
  $attachmentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMessageAttachmentFilterInput
  $limit: Int
  $nextToken: String
) {
  messageAttachmentsByAttachmentId(
    attachmentId: $attachmentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      messageId
      attachmentId
      message {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      attachment {
        id
        name
        description
        type
        status
        size
        s3Key
        uploadDate
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessageAttachmentsByAttachmentIdQueryVariables,
  APITypes.MessageAttachmentsByAttachmentIdQuery
>;
export const getMessageByIdWithBody = /* GraphQL */ `query GetMessageByIdWithBody($id: ID!) {
  getMessageByIdWithBody(id: $id) {
    id
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    status
    scheduledDate
    endOfLifeTrigger
    size
    userprofileID
    Recipients {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sentDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessageByIdWithBodyQueryVariables,
  APITypes.GetMessageByIdWithBodyQuery
>;
export const getDeliveredMessageByIdWithBody = /* GraphQL */ `query GetDeliveredMessageByIdWithBody($id: ID!) {
  getDeliveredMessageByIdWithBody(id: $id) {
    id
    recipientEmail
    recipientId
    recipientUserId
    deliveredAt
    deliveryType
    messageRead
    readReminderCount
    readReminderStatus
    status
    failureReason
    attemptCount
    lastAttemptAt
    statusUpdatedAt
    fromUserProfileId
    fromName
    fromEmail
    originalMessageId
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    hasAttachment
    attachmentCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDeliveredMessageByIdWithBodyQueryVariables,
  APITypes.GetDeliveredMessageByIdWithBodyQuery
>;
export const getMyEffectivePlatformLimits = /* GraphQL */ `query GetMyEffectivePlatformLimits {
  getMyEffectivePlatformLimits {
    maxRecipientsPerMessage
    maxAttachmentsPerMessage
    maxGeneralFileSizeBytes
    maxVideoFileSizeBytes
    maxStorageBytesPerUser
    maxTotalAttachmentSizePerMessage
    allowedExtensions
    storageUsedBytes
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMyEffectivePlatformLimitsQueryVariables,
  APITypes.GetMyEffectivePlatformLimitsQuery
>;
